import { ResourceKey } from "i18next";

export const RelatedTenders: ResourceKey = {
	relatedTendersTitle: "Gerelateerde opdrachten",
	callToAction: "Registreer je in een paar seconden om meer relevante opdrachten te zien",
}